import React from 'react';

import { Skeleton } from '@mui/material';

import styles from './SortListings.module.css';

const SortListingsSkeleton = () => {
  return (
    <div className={styles.root}>
      <div className={styles.headerSection}>
        {/* chips row */}
        <div className={styles.chipRow}>
          <Skeleton variant="rounded" width={90} height={26} />
          <Skeleton variant="rounded" width={110} height={26} />
        </div>
        {/* title */}
        <Skeleton variant="text" width="60%" height={36} />
        {/* subtitle */}
        <Skeleton variant="text" width="40%" height={20} />
      </div>

      <div className={styles.sortDropdown}>
        <Skeleton variant="rounded" width={180} height={40} />
      </div>
    </div>
  );
};

export default SortListingsSkeleton;
